import { render, staticRenderFns } from "./FormHeadCreate.vue?vue&type=template&id=176d83f2&scoped=true"
import script from "./FormHeadCreate.vue?vue&type=script&lang=js"
export * from "./FormHeadCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d83f2",
  null
  
)

export default component.exports